import { API } from "@/constants/common";
import { apiClient } from "../client/apiClient";
import { PortfolioItem } from "./type";

export class PortfolioService {
  static instance: PortfolioService;

  public static QUERY_KEY = {
    BASE: 'portfolio',
    FETCH_ALL: ['portfolio', 'fetch_all'],
  };

  constructor() {
    if (PortfolioService.instance) {
      return PortfolioService.instance;
    }
    PortfolioService.instance = this;
  }

  async getCategoryList(): Promise<PortfolioItem[]> {
    const data = await apiClient.get(API.PORTFOLIO.CATEGORY);
    return data.data;
  }
}